import { List, Box } from '@global-engineering-shared/gweb-material-ui';
import { combineClasses } from '@global-engineering-shared/object-utils';
import classNames from 'classnames';

import useStyles from 'components/Table/Table.styles';
import { ITable } from 'components/Table/types/Table';

import TableItem from './components/TableItem/TableItem';

const Table = ({
  items,
  keyName,
  collapsedContent,
  handleRowClick,
  columns,
  tableItemGridTemplate,
  classes: userClasses = {},
  expandOnClick,
  itemStyle,
}: ITable) => {
  const classes = combineClasses(useStyles(), userClasses);
  return (
    <Box>
      <List className={classNames(classes.tableContainer, classes.table)}>
        {items?.map((item) => (
          <TableItem
            key={item[keyName]}
            keyName={keyName}
            item={item}
            handleRowClick={handleRowClick}
            collapsedContent={collapsedContent}
            columns={columns}
            tableItemGridTemplate={tableItemGridTemplate}
            classes={classes}
            expandOnClick={expandOnClick}
            itemStyle={itemStyle}
          />
        ))}
      </List>
    </Box>
  );
};

export default Table;
